import { render } from "./DataBlend.vue?vue&type=template&id=bc2d48b8"
import script from "./DataBlend.vue?vue&type=script&setup=true&lang=js"
export * from "./DataBlend.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Settings/DataBlend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc2d48b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc2d48b8', __exports__)) {
    api.reload('bc2d48b8', __exports__)
  }
  
  module.hot.accept("./DataBlend.vue?vue&type=template&id=bc2d48b8", () => {
    api.rerender('bc2d48b8', render)
  })

}


export default __exports__